import React from 'react';
export const Logo = ({
  isSmall = false
}) => {
  const svgSize = isSmall ? 60 : 120;
  const textClass = isSmall ? 'text-xl font-serif tracking-wider text-slate-800' : 'text-3xl font-serif tracking-wider text-slate-800';
  const subtitleClass = isSmall ? 'text-sm tracking-widest text-slate-700 mt-0.5' : 'text-xl tracking-widest text-slate-700 mt-1';
  return <div className={`flex ${isSmall ? 'flex-row items-center gap-3' : 'flex-col items-center'}`} data-id="element-140">
      {/* Logo Symbol */}
      <div className={isSmall ? '' : 'relative mb-4'} data-id="element-141">
        <svg width={svgSize} height={svgSize} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="logoTitle" role="img" data-id="element-142">
          <title id="logoTitle" data-id="element-143">Aurum Grove Capital Logo</title>
          {/* Outer circle */}
          <circle cx="60" cy="60" r="58" stroke="#D4AF37" strokeWidth="4" fill="transparent" data-id="element-144" />
          {/* Inner circle */}
          <circle cx="60" cy="60" r="48" stroke="#D4AF37" strokeWidth="2" fill="transparent" data-id="element-145" />
          {/* Stylized tree/growth symbol */}
          <path d="M60 20 L60 85" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-146" />
          <path d="M60 40 L45 55" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-147" />
          <path d="M60 50 L45 65" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-148" />
          <path d="M60 60 L45 75" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-149" />
          <path d="M60 40 L75 55" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-150" />
          <path d="M60 50 L75 65" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-151" />
          <path d="M60 60 L75 75" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" data-id="element-152" />
          {/* Stylized base/foundation */}
          <path d="M40 85 C40 85, 60 75, 80 85" stroke="#D4AF37" strokeWidth="3" fill="transparent" strokeLinecap="round" data-id="element-153" />
        </svg>
      </div>
      {/* Company Name */}
      <div className="text-center" data-id="element-154">
        <h1 className={textClass} data-id="element-155">
          <span className="text-[#D4AF37]" data-id="element-156">AURUM</span> GROVE
        </h1>
        <p className={subtitleClass} data-id="element-157">CAPITAL</p>
      </div>
    </div>;
};